import styled from 'styled-components';

export const $MenuList = styled.div`
  padding: 10px;
  bordertop: 1px solid #eee;
  textalign: center;
  color: ${({ theme }) => theme.colors.primary};
  fontweight: ${({ theme }) => theme.fonts.weight.mediumFont};
  cursor: pointer;
`;
